module.exports = __webpack_public_path__ + "media/images/lb/300-5d38f3f4ce42b30caad0281945285a06.svg";